<template>
  <ra-card>
    <template slot="header">
      <p>Signups By Type</p>
    </template>
    <template slot="content">
      <doughnut-chart
        v-if="dataAvailable"
        :data="requestChart.data"
        :labels="requestChart.labels"
        :height="200"
      />
      <ra-empty-state v-else :type="'pie-chart'" />
    </template>
  </ra-card>
</template>

<script>
import apiConstants from "@/apiConstants";
import DoughnutChart from "@/components/Chart/DoughnutChart";

export default {
  name: "SignupsByType",
  props: {
    appCode: {
      type: String,
      default: ""
    },
    period: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    DoughnutChart
  },
  data() {
    return {
      authTypes: [],
      labels: [],
      data: [],
      noAccessCodes: apiConstants.NO_ACCESS_CODES
    };
  },
  computed: {
    requestChart() {
      const labels = this.labels;
      const data = this.data;

      return { data, labels };
    },

    dataAvailable() {
      return this.labels.length && this.data.length;
    }
  },

  watch: {
    appCode() {
      this.getSignupsByType();
    },
    period: {
      deep: true,
      handler() {
        this.getSignupsByType();
      }
    }
  },
  created() {
    if (this.userCan("authx", "global.getauthtypes")) {
      this.getAuthTypes();
    }

    if (this.appCode) {
      this.getSignupsByType();
    }
  },
  methods: {
    getAuthTypes() {
      this.$http
        .post(
          "auth/types",
          {
            method: "GET"
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.AUTHX
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.authTypes = resData;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    },
    getSignupsByType() {
      const { start_at, end_at } = this.period;
      const filter_by = "done_at";
      const group = "auth_type_id";
      const count = "user_id";
      const queries = `start_at=${start_at}&end_at=${end_at}&filter_by=${filter_by}&group_by=${group}&count_by=${count}`;

      const apiUrl = `apps/${this.appCode}/stats/grouped/sign-ups?${queries}`;
      this.$http
        .post(
          apiUrl,
          {
            method: "GET"
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.AUTHX
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.formatChartData(resData);
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    },

    formatChartData(data) {
      this.labels = [];
      this.data = [];

      if (data.length === 0) {
        return;
      }
      this.authTypes.forEach(type => {
        const count = data[type.id.toString()] || 0;
        const label = `${type.name} (${count})`;
        this.labels.push(label);
        this.data.push(count);
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
